import { Button, useMediaQuery, useTheme } from "@mui/material";
import { IssueListTooltip } from "components/IssueListTooltip";
import { Issue } from "generated-graphql/graphql";
import pluralize from "pluralize";
import { useMemo, useState } from "react";

export const IssueListButton = ({
  issues,
  issueCount,
  issueDescriptor = "Compliance",
  getIssueDescription,
}: {
  issues: Issue[];
  /** Total number of issues. Used if not all issues are present in the issues prop. */
  issueCount?: number;
  issueDescriptor?: string;
  getIssueDescription?: (issue: Issue) => string;
}) => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);

  const toggleTooltip = () => {
    setOpen((open) => !open);
  };

  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));

  const descriptor = useMemo(() => {
    const numIssues = issueCount ?? issues.length;
    return `${numIssues > 0 ? numIssues : "No"} ${issueDescriptor} ${pluralize(
      "Issue",
      numIssues
    )}`;
  }, [issueDescriptor, issueCount, issues.length]);

  const buttonLabel = useMemo(() => {
    if (isLargeScreen) {
      return descriptor;
    }
    return "Issues";
  }, [descriptor, isLargeScreen]);

  return (
    <IssueListTooltip
      issues={issues}
      issueCount={issueCount}
      open={open}
      onClose={() => setOpen(false)}
      getIssueDescription={getIssueDescription}
      header={descriptor}
    >
      <Button
        type="button"
        color="error"
        onClick={toggleTooltip}
        disabled={!issues?.length}
        variant="text"
      >
        {buttonLabel}
      </Button>
    </IssueListTooltip>
  );
};
